import React, { Component } from "react";
import { Container, Row, Col } from "react-bootstrap";
import emailjs from "emailjs-com";
import Swal from "sweetalert2";

const SERVICE_ID = "service_3qq5tmg";
const TEMPLATE_ID = "template_g3mrj1g";
const PUBLIC_KEY = "4EA9FyotVNbcsvPoR";

class EmailContactForm extends Component {
  state = {
    name: "",
    email: "",
    mobile: "",
    address: "",
    message: "",
    emailStatus: "",
  };

  handleChange = (input) => (e) => {
    this.setState({ [input]: e.target.value });
  };

  submitForm = (e) => {
    e.preventDefault();
    const { name, email, mobile, address, message } = this.state;

    const templateParams = {
      from_name: name,
      from_email: email,
      mobile: mobile,
      address: address,
      message: message,
    };

    emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, PUBLIC_KEY)
      .then((response) => {
        Swal.fire({
          icon: 'success',
          title: 'Message Sent!',
          text: 'Your message has been successfully sent.',
        });
        this.setState({
          name: "",
          email: "",
          mobile: "",
          address: "",
          message: "",
          emailStatus: "success",
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong! Please try again.',
        });
        this.setState({ emailStatus: "error" });
      });
  };

  render() {
    const { name, email, mobile, address, message, emailStatus } = this.state;
    return (
      <Container>
        <Row>
          <Col lg={6} className="order-lg-first">
            <h2 className="mb-3">Contact us</h2>
            <div className="formBlock" style={{ padding: "20px", backgroundColor: "#f8f9fa", borderRadius: "8px" }}>
              {emailStatus === "success" && (
                <div className="alert alert-success mb-3">Message sent successfully!</div>
              )}
              {emailStatus === "error" && (
                <div className="alert alert-danger mb-3">Failed to send message. Please try again.</div>
              )}
              <form onSubmit={this.submitForm}>
                <div className="mb-3">
              
                  <input
                    className="form-control"
                    type="text"
                    id="name"
                    value={name}
                    onChange={this.handleChange("name")}
                    placeholder="Enter your name"
                    required
                  />
                </div>
                <div className="mb-3">
              
                  <input
                    className="form-control"
                    type="email"
                    value={email}
                    onChange={this.handleChange("email")}
                    id="email"
                    placeholder="Enter your email"
                    required
                  />
                </div>
                <div className="mb-3">
                
                  <input
                    className="form-control"
                    type="tel"
                    id="mobile"
                    value={mobile}
                    onChange={this.handleChange("mobile")}
                    placeholder="Enter your mobile number"
                    required
                  />
                </div>
                <div className="mb-3">
              
                  <input
                    className="form-control"
                    type="text"
                    id="address"
                    value={address}
                    onChange={this.handleChange("address")}
                    placeholder="Enter your address"
                    required
                  />
                </div>
                <div className="mb-3">
                  <textarea
                    className="form-control"
                    id="message"
                    value={message}
                    onChange={this.handleChange("message")}
                    placeholder="Enter your message"
                    rows="4"
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary btn-lg">
                  Send Email
                </button>
              </form>
            </div>
          </Col>
          <Col lg={6} className="order-lg-last">
            <div style={{ paddingTop: "110px" }}></div>
            <p style={{ fontWeight: "bold", fontSize: "30px", color: "black" }}>
              EBS Software Solution
            </p>
            <p style={{ textAlign: "justify" }}>
              EBS Software Solution,is one of the fastest growing software
              developments.The establishing objectives was to be the most
              dependable organization providing impeccable service, premium
              products and comprehensive solutions to the customers in India.
            </p>
            <ul>
              <li style={{ fontWeight: "bold" }}>Address:</li>
              <li>EBS IT Park,Near Uttar Banga Sambad Press,Madhya Shanti Nagar Siliguri,</li>
              <li>Jalpaiguri, West Bengal, INDIA,Pin-734004</li>
              <li>Office : +91 353 405 5548</li>
              <li>Sales & Support : +91 97337 21111, 99320 13501</li>
              <li>Email : info@ebssoftware.co.in || ebs.slg@gmail.com</li>
            </ul>
            <br />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default EmailContactForm;